import React from "react";
import PropTypes from "prop-types";

const DeleteIcon = ({
  color = "currentColor",
  width = 20,
  height = 23,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.75 22.5C3.0625 22.5 2.47396 22.2552 1.98438 21.7656C1.49479 21.276 1.25 20.6875 1.25 20V3.75H0V1.25H6.25V0H13.75V1.25H20V3.75H18.75V20C18.75 20.6875 18.5052 21.276 18.0156 21.7656C17.526 22.2552 16.9375 22.5 16.25 22.5H3.75ZM16.25 3.75H3.75V20H16.25V3.75ZM6.25 17.5H8.75V6.25H6.25V17.5ZM11.25 17.5H13.75V6.25H11.25V17.5Z"
        fill={color}
      />
    </svg>
  );
};

DeleteIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

DeleteIcon.defaultProps = {
  color: "currentColor",
  width: 20,
  height: 23,
};

export default DeleteIcon;
